import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { BrokerService } from '../../services/api/broker.service';
import { NotificationService } from '../../services/notification.service';
import { PositionService } from '../../services/api/position.service';
import { TradeboardService } from '../../services/api/tradeboard.service';
import { DataService } from '../../services/data.service';
import { JqueryUtils } from '../../utils/jquery.utils';

@Component({
  selector: 'app-tradeboard-content',
  templateUrl: './tradeboard-content.component.html',
  styleUrls: ['./tradeboard-content.component.scss']
})
export class TradeboardContentComponent implements OnInit {

  @Input()
  data: any;

  tradeboard: any = {
    selected_class: { settings: { active: 1 }, positions: { active: 0 } },
    params: {
      symbol: { name: '' },
      product_type: { name: '' }
    },
    users: [],
    contracts: [],
    tgt: {
      type: { name: '' },
      lot_allocation: { name: '' }
    },
    sl: {
      type: { name: '' },
      lot_allocation: { name: '' }
    },
    tsl: {
      type: { name: '' },
      mechanism: { name: '' }
    }
  };
  bas: any = [];
  positions = [];
  orders = [];
  user_positions: any;
  product_types = [
    { name: "MIS" },
    { name: "NRML" }
  ];
  symbols = [
    { name: "Nifty", lot_size: 50, min_size: 50, max_size: 1000, strike_diff: 50 },
    { name: "Banknifty", lot_size: 25, min_size: 25, max_size: 1000, strike_diff: 100 }
  ];
  option_types = [
    { name: "CE"},
    { name: "PE"}
  ];
  order_types = [
    { name: "MKT"},
    { name: "LIMIT"},
    { name: "SL"}
  ];
  tgt_types = [
    { name: "Percent" },
    { name: "Pts" }
  ];
  sl_types = [
    { name: "Percent" },
    { name: "Pts" }
  ];
  tsl_types = [
    { name: "Target" },
    { name: "Percent" },
    { name: "Pts" }
  ];
  lot_alloc_types = [
    { name: "Ascending Divider" },
    { name: "Descending Divider" },
    { name: "Pyramid" },
    { name: "Inverted Pyramid" }
  ];
  tsl_mechanisms = [
    { name: "CTC on Target" },
    { name: "CTC then Step up on Target" },
    { name: "Step up on Target" },
  ];

  constructor(private brokerService: BrokerService, private tradeboardService: TradeboardService,
    private dataService: DataService, private router: Router, private notificationService: NotificationService,
    private positionService: PositionService, private jq: JqueryUtils) { }

  ngOnInit(): void {
    this.loadBrokerAccounts();
  }

  loadBrokerAccounts() {
    this.brokerService.getAllBrokers({bname: 'alice_blue'}).subscribe((response: any) => {
      if (response.response_code == 1000) {
        this.bas = response.bas;
        this.tradeboard = JSON.parse(JSON.stringify(this.data));
        this.tradeboard = this.calculateTradeboardDatas(this.tradeboard);
      }
    });
  }

  onProductTypeSelected() {

  }

  onSymbolSelected() {
    let symbol = this.get_symbol_by_name(this.tradeboard.params.symbol.name);
    if (symbol == null) {
      this.notificationService.showAlert("error", "Symbol should be selected.")
      return;
    }
    this.tradeboard.params.symbol = symbol;
    this.tradeboard.params.lot_size = this.tradeboard.params.symbol.lot_size;
    this.tradeboard.params.max_lot_size = this.tradeboard.params.symbol.max_size;
    this.tradeboard.params.min_lot_size = this.tradeboard.params.symbol.min_size;
    this.tradeboard.params.quantity = this.tradeboard.params.symbol.lot_size;
    this.tradeboard.params.strike_diff = this.tradeboard.params.symbol.strike_diff;
  }

  onClientIDSelected(user: any) {
    let ba = this.get_client_by_id(user.ba._id);
    if (ba == null) {
      this.notificationService.showAlert("error", "Client ID should be selected.")
      return;
    }
    user.ba = ba;
  }

  onOptionTypeSelected(contract: any) {
    let opt = this.get_option_type_by_name(contract.option_type.name);
    if (opt == null) {
      this.notificationService.showAlert("error", "Option Type should be selected.")
      return;
    }
    contract.option_type = opt;
  }

  onOrderTypeSelected(contract: any) {
    let ot = this.get_order_type_by_name(contract.order_type.name);
    if (ot == null) {
      this.notificationService.showAlert("error", "Order Type should be selected.")
      return;
    }
    contract.order_type = ot;
    contract.price_enabled = ['LIMIT', 'SL'].indexOf(ot.name.toUpperCase()) > -1;
    contract.trigger_price_enabled = ['SL'].indexOf(ot.name.toUpperCase()) > -1;
  }

  updateParams() {

  }

  getFilteredBas(user: any) {
    let user_bas = JSON.parse(JSON.stringify(this.bas));
    let added_users = JSON.parse(JSON.stringify(this.tradeboard.users));
    for (let idx = (user_bas.length - 1); idx >= 0; idx--) {
      for (let jdx = 0; jdx < added_users.length; jdx++) {
        if (!user) {
          if (added_users[jdx].client_id == user_bas[idx].params.client_id) {
            user_bas.splice(idx, 1);
            break;
          }
        } else {
          if ((user.client_id != added_users[jdx].client_id) && (added_users[jdx].client_id == user_bas[idx].params.client_id)) {
            user_bas.splice(idx, 1);
            break;
          }
        }
      }
    }
    return user_bas;
  }

  addUser() {
    let filtered_bas = this.getFilteredBas(null);
    if (filtered_bas.length <= 0) {
      this.jq.openModal('addUserAlertModal');
      return;
    }
    let ba = JSON.parse(JSON.stringify(filtered_bas[0]));
    let user = {
      bas: filtered_bas,
      broker_acc_id: ba._id,
      broker_name: ba.name,
      client_id: ba.params.client_id,
      quantity: this.tradeboard.params.quantity
    }
    let users = this.tradeboard.users;
    users.push(user);
    this.tradeboard.users = users;
  }

  closeAddUserAlertModal() {
    this.jq.closeModal('addUserAlertModal');
  }

  addContracts() {
    let contract = {
      option_type: JSON.parse(JSON.stringify(this.option_types[0])),
      order_type: JSON.parse(JSON.stringify(this.order_types[0]))
    }
    let contracts = this.tradeboard.contracts;
    contracts.push(contract);
    this.onOrderTypeSelected(contract);
    this.tradeboard.contracts = contracts;
  }

  placeOrder(contract: any, side: any) {

  }

  placeExitOrder(user: any, position: any, side: any) {

  }

  deleteContract(idx: any, contract: any) {
    let contracts = this.tradeboard.contracts;
    contracts = contracts.splice(idx, 1);
    this.tradeboard.contracts = contracts;
  }

  saveDetails() {
    let contracts: any = [];
    for (let idx = 0; idx < this.tradeboard.contracts.length; idx ++) {
      contracts.push({
        strike: this.tradeboard.contracts[idx].strike,
        option_type: this.tradeboard.contracts[idx].option_type.name,
        order_type: this.tradeboard.contracts[idx].order_type.name,
        price: this.tradeboard.contracts[idx].price,
        trigger_price: this.tradeboard.contracts[idx].trigger_price
      });
    }
    let tb: any = {
      name: this.tradeboard.name,
      params: {
        symbol: this.tradeboard.params.symbol.name,
        product_type: this.tradeboard.params.product_type.name,
        quantity: this.tradeboard.params.quantity
      },
      users: this.tradeboard.users,
      contracts: contracts,
      tgt: this.tradeboard.tgt,
      sl: this.tradeboard.sl,
      tsl: this.tradeboard.tsl
    };
    if (this.tradeboard.edit_mode) {
      this.tradeboardService.updateTradeboard(tb).subscribe((response: any) => {
        this.tradeboard = this.calculateTradeboardDatas(response.tradeboard);
        this.dataService.tradeboardUpdated(response.tradeboard);
      });
    } else {
      this.tradeboardService.addTradeboard(tb).subscribe((response: any) => {
        this.tradeboard = this.calculateTradeboardDatas(response.tradeboard);
        this.dataService.removeTradeboard(response.tradeboard);
        this.dataService.tradeboardAdded(response.tradeboard);
      });
    }
  }

  closeTradeboard() {
    this.dataService.removeTradeboard(this.tradeboard);
    let tb = this.dataService.getTradeboardAt(0);
    if (tb != null) {
      this.dataService.tradeboardOpened(tb);
    } else {
      this.router.navigate(['/tah', 'tblist']);
    }
  }

  refreshDatas() {

  }

  modifyOrder(order: any) {

  }

  cancelOrder(order: any) {
    
  }

  deleteUser(idx: any, user: any) {
    let users: any = this.tradeboard.users;
    users.splice(idx, 1);
    this.tradeboard.users = users;
  }

  get_order_type_by_name(name: any) {
    let ot: any = null;
    for (let idx = 0; idx < this.order_types.length; idx++) {
      if (this.order_types[idx].name == name) {
        ot = JSON.parse(JSON.stringify(this.order_types[idx]));
        break;
      }
    }
    return ot;
  }

  get_option_type_by_name(name: any) {
    let opt: any = null;
    for (let idx = 0; idx < this.option_types.length; idx++) {
      if (this.option_types[idx].name == name) {
        opt = JSON.parse(JSON.stringify(this.option_types[idx]));
        break;
      }
    }
    return opt;
  }

  get_client_by_id(_id: any) {
    let ba = null;
    for (let idx = 0; idx < this.bas.length; idx++) {
      if (this.bas[idx]._id == _id) {
        ba = JSON.parse(JSON.stringify(this.bas[idx]));
        break;
      }
    }
    return ba;
  }

  get_symbol_by_name(name: any) {
    let symbol = null;
    for (let idx = 0; idx < this.symbols.length; idx++) {
      if (this.symbols[idx].name == name) {
        symbol = JSON.parse(JSON.stringify(this.symbols[idx]));
        break;
      }
    }
    return symbol;
  }

  get_product_type_by_name(name: any) {
    let product_type = null;
    for (let idx = 0; idx < this.product_types.length; idx++) {
      if (this.product_types[idx].name == name) {
        product_type = JSON.parse(JSON.stringify(this.product_types[idx]));
        break;
      }
    }
    return product_type;
  }

  calculateTradeboardDatas(tb: any) {
    let tradeboard = JSON.parse(JSON.stringify(tb));
    for (let idx = 0; idx < tradeboard.users.length; idx++) {
      tradeboard.users[idx].bas = this.getFilteredBas(tradeboard.users[idx]);
    }
    if (tradeboard.params.symbol && tradeboard.params.symbol != null) {
      tradeboard.params.symbol = this.get_symbol_by_name(tradeboard.params.symbol);
    } else {
      tradeboard.params.symbol = JSON.parse(JSON.stringify(this.symbols[0]));
    }
    tradeboard.params.lot_size = tradeboard.params.symbol.lot_size;
    tradeboard.params.max_lot_size = tradeboard.params.symbol.max_size;
    tradeboard.params.min_lot_size = tradeboard.params.symbol.min_size;
    tradeboard.params.strike_diff = tradeboard.params.symbol.strike_diff;
    if (tradeboard.params.product_type) {
      tradeboard.params.product_type = this.get_product_type_by_name(tradeboard.params.product_type);
    } else {
      tradeboard.params.product_type = JSON.parse(JSON.stringify(this.product_types[0]));
    }
    for (let idx = 0; idx < tradeboard.contracts.length; idx++) {
      tradeboard.contracts[idx].option_type = this.get_option_type_by_name(tradeboard.contracts[idx].option_type);
      tradeboard.contracts[idx].order_type = this.get_order_type_by_name(tradeboard.contracts[idx].order_type);
    }
    tradeboard.tgt = tradeboard.tgt || { total: 1, type: JSON.parse(JSON.stringify(this.tgt_types[0])),
                                         step_value: 1, lot_allocation: JSON.parse(JSON.stringify(this.lot_alloc_types[0])) };
    tradeboard.sl = tradeboard.sl || { total: 1, type: JSON.parse(JSON.stringify(this.sl_types[0])),
                                         step_value: 1, lot_allocation: JSON.parse(JSON.stringify(this.lot_alloc_types[0])) };
    tradeboard.tsl = tradeboard.tsl || { type: JSON.parse(JSON.stringify(this.tsl_types[0])), enabled: false,
                                          mechanism: JSON.parse(JSON.stringify(this.tsl_mechanisms[0])) };
    tradeboard.selected_class = tradeboard.selected_class || { settings: { active: 0 }, positions: { active: 0 } };
    tradeboard.selected_class.settings = { active: 1 };
    tradeboard.selected_class.positions = { active: 0 };
    return tradeboard;
  }

  onTabSelected(selected_tab: any) {
    this.tradeboard.selected_class.settings = { active: (selected_tab == 'settings') ? 1 : 0 };
    this.tradeboard.selected_class.positions = { active: (selected_tab == 'positions') ? 1 : 0 };
    if (selected_tab == 'positions') {
      if (this.tradeboard.users.length > 0) {
        let ups: any = [];
        for (let idx = 0; idx < this.tradeboard.users.length; idx++) {
          ups.push({
            user:JSON.parse(JSON.stringify(this.tradeboard.users[idx])),
            accordion_id:`collapse${this.tradeboard.users[idx].client_id}`,
            accordion_tgt_id:`#collapse${this.tradeboard.users[idx].client_id}`,
            accordion_heading:`header_${this.tradeboard.users[idx].client_id}`,
            selected:(idx == 0) ? {show: 1} : {show:0},
            collapse:(idx == 0) ? {collapsed: 0} : {collapsed:1},
            positions: [],
            orders: []
          });
        }
        this.user_positions = ups;
        this.loadPositions(this.user_positions[0]);
      }
    }
  }

  loadPositions(user_position: any) {
    this.positionService.getPositions({bacc_id: user_position.user.broker_acc_id}).subscribe((response: any) => {
      user_position.positions = response.positions;
    });
  }

  onAccordionItemClick(userPosition: any) {
    let selected: any = { show: (userPosition.selected.show == 1) ? 0 : 1 };
    userPosition.selected = selected;
    if (userPosition.selected.show == 1) {
      this.loadPositions(userPosition);
    }
  }

  onTargetTypeSelected() {

  }

  onSLTypeSelected() {

  }

  onTSLTypeSelected() {

  }

  onTgtLotAllocationSelected() {

  }

  onSLLotAllocationSelected() {

  }

  onTSLMechanismSelected() {

  }
}
